import React from 'react';
import styled from 'styled-components';
import Logo from '../../images/cam_x_theo.svg';

const Headline = styled.h3`
  display: none;
  @media (max-width: 768px) {
    display: block;
    text-transform: none;
    font-weight: normal;
    width: 100%;
    text-align: center;
    padding-bottom: 2rem;
  }
`

const MobileTitle = (props) => {

  const { title } = props;

  let HeadlineText;

  if(title == 'camille-charriere-x-theo') {
    HeadlineText = <img src={Logo} />
  } else if(title == 'sale-40-off') {
    HeadlineText = '';
  } else {
    HeadlineText = title.charAt(0).toUpperCase() + title.slice(1);
  }

  return(
    <Headline>
      {HeadlineText}
    </Headline>
  )
}

export default MobileTitle;
